import React, { useState } from 'react'
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import { Button } from '@app/components';
import { Form, Modal } from 'react-bootstrap';
import { updateSubjectThresholdById } from '@app/services/subject';

const UpdateSubjectPrintThresholdModal = (props) => {

    const [isLoading, setLoading] = useState(false);

    const updateThresholdAPI = async (payload) => {
        try {
            setLoading(true);
            const resp = await updateSubjectThresholdById(payload);
            if(resp.success === true){
                setLoading(false);
                toast.success(resp?.message);
                props.handleClose();
                props.getAllSubjectsAPI();
            }else{
                toast.error(resp?.errors[0]?.msg);
                setLoading(false);
            }
        } catch (error: any) {
            setLoading(false);
            toast.error(error?.response?.message || 'Failed');
        }
    };

    const { handleChange, values, handleSubmit, touched, errors } = useFormik({
        initialValues: {
            id: props?.subject?.id ?? '',
            worksheet_count_threshold: props?.subject?.worksheet_count_threshold ?? '',
        },
        validationSchema: Yup.object({
            worksheet_count_threshold: Yup.number()
                .required('Please enter worksheet count')
                .positive('Please enter valid positive number')
                .integer('Please enter valid positive number'),
        }),
        onSubmit: (values) => {
            updateThresholdAPI(values);
        },
        enableReinitialize: true,
    });

    return (
    <div>
        <Modal show={props.show} onHide={props.handleClose} size="sm">
            <Modal.Header closeButton>
                <Modal.Title>Update Print Threshold</Modal.Title>
            </Modal.Header>
            <form onSubmit={handleSubmit}>
                <Modal.Body>
                    <div className='row'>
                        <div className="col-sm-12">
                            <div className="form-group">
                                <dt>Subject Name </dt>
                                <dd>{ props?.subject?.name } </dd>
                            </div>
                        </div>
                        <div className="col-sm-12">
                            <div className="form-group">
                                <label htmlFor="worksheet_count_threshold">Monthly Print Threshold Per Student<span className="required">*</span></label>
                                <Form.Control 
                                    type="number" 
                                    name="worksheet_count_threshold" 
                                    id="worksheet_count_threshold" 
                                    placeholder="Enter worksheet count" 
                                    value={values.worksheet_count_threshold}
                                    onChange={handleChange}
                                    onWheel={ (e) => e.currentTarget.blur() }
                                    min="1"
                                />
                                {(touched.worksheet_count_threshold && errors.worksheet_count_threshold) && (
                                    <div className="text-danger">
                                        {errors.worksheet_count_threshold}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button type="submit" isLoading={isLoading} className="btn btn-primary mr-2">Update </Button>
                    <Button className='btn btn-default' onClick={props.handleClose}>Close</Button>
                </Modal.Footer>
            </form>
        </Modal>
    </div>
  )
}

export default UpdateSubjectPrintThresholdModal;
